import { QuestionnaireSubsectionConfig } from 'data/questionnaire-config-type';

export function isCriticalItem(
  value: number,
  min: number,
  max: number,
  threshold: number
) {
  return (value - min) / (max - min) <= threshold;
}

export interface IsCriticalItemFromConfigArgs {
  value: string | number | boolean | string[];
  threshold: number;
  config: Pick<QuestionnaireSubsectionConfig, 'iconsForward' | 'min' | 'max'>;
}

export function isCriticalItemFromConfig({
  value,
  threshold,
  config
}: IsCriticalItemFromConfigArgs) {
  if (isNaN(Number(value))) {
    throw new Error(
      `[isCriticalItemFromConfig] Value (value=${value}) is not a number`
    );
  }

  return isCriticalItem(
    value as number,
    config.iconsForward ? config.min : config.max,
    config.iconsForward ? config.max : config.min,
    threshold
  );
}
